<template>
  <div>
    <Navbar activeDirectory="home"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-3">
          <div class="card">
            <div class="card-body">
              <h2 class="font-bold">Lotto: {{ lotto }}</h2>
              <a class="btn btn-primary text-white" @click="cambiaLotto()">Cambia</a>
            </div>
          </div>
        </div>
        <div class="col-9">
          <div class="row">
            <div class="col">
              <div class="widget-bg-color-icon card-box">
                <div class="bg-icon bg-icon-purple pull-left">
                  <i class="mdi text-success" :class="[{'mdi-forklift': !reportLoading}, {'mdi mdi-refresh' : reportLoading}]"></i>
                </div>
                <div class="text-right">
                  <h3 class="text-dark m-t-10">
                    <b class="counter">{{ report.bucheRiparate.toLocaleString() }}</b>
                  </h3>
                  <p class="text-muted mb-0">Buche Riparate</p>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="col">
              <div class="widget-bg-color-icon card-box">
                <div class="bg-icon bg-icon-primary pull-left">
                  <i class="mdi text-success" :class="[{'mdi-ruler': !reportLoading}, {'mdi mdi-refresh' : reportLoading}]"></i>
                </div>
                <div class="text-right">
                  <h3 class="text-dark m-t-10">
                    <b class="counter">{{ report.metriSfalciati.toLocaleString() }}</b>
                  </h3>
                  <p class="text-muted mb-0">Metri Sfalciati</p>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="col">
              <div class="widget-bg-color-icon card-box">
                <div class="bg-icon bg-icon-success pull-left">
                  <i class="mdi text-success"  :class="[{'mdi-truck': !reportLoading}, {'mdi mdi-refresh' : reportLoading}]"></i>
                </div>
                <div class="text-right">
                  <h3 class="text-dark m-t-10">
                    <b class="counter">{{ report.squadreAttive }} / {{ report.squadreTotali }}</b>
                  </h3>
                  <p class="text-muted mb-0">Squadre attive</p>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="col">
              <div class="widget-bg-color-icon card-box">
                <div class="bg-icon bg-icon-warning pull-left">
                  <i class="mdi text-success"  :class="[{'mdi-road': !reportLoading}, {'mdi mdi-refresh' : reportLoading}]"></i>
                </div>
                <div class="text-right">
                  <h3 class="text-dark m-t-10">
                    <b class="counter">{{ report.strade }}</b>
                  </h3>
                  <p class="text-muted mb-0">Strade</p>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="card m-b-20">
            <h4 class="card-header font-bold">Notifiche Push</h4>
            <div class="card-body">
              <div v-if="permission == 'denied' || permission == 'default'">
                <button class="btn btn-warning" @click="changeNotificationPermission()">Abilita</button>
              </div>
              <span v-else><b>Abilitate</b></span>
            </div>
          </div>

          <div class="card m-b-20">
            <h4 class="card-header font-bold">Riepilogo Squadre</h4>
            <div class="card-body">
              <div>
                <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarTeams >= 100}, {'bg-success': progressBarTeams < 100}]" role="progressbar" :style="{width: `${progressBarTeams}%`}" :aria-valuenow="progressBarTeams" aria-valuemin="0" aria-valuemax="100"></div></div>
              </div>
              <table class="table table-striped table-sm">
                <thead class="thead-light">
                  <th>Squadra</th>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in teams" v-bind:key="key">
                    <td>{{ item.team }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer">
              <select class="form-control" v-model="gruppoSelezionato">
                <option>Tutte</option>
                <option value="C">Centro</option>
                <option value="T">Tronco</option>
                <option value="S">Sorveglianza</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-9">
          <!-- Schede -->
          <div class="text-left">
            <a
              class="btn text-white btn-sm ml-2 mr-2"
              :class="[{'btn-primary':activeView=='Segnalazioni inviate'},{'btn-secondary': activeView!='Segnalazioni inviate'}]"
              @click="activeView='Segnalazioni inviate'"
            >
              Segnalazioni inviate
              <span
                class="badge badge-pill"
                :class="[{'badge-success':activeView=='Segnalazioni inviate'},{'badge-dark': activeView!='Segnalazioni inviate'}]"
              >{{ segnalazioni.length }}</span>              
            </a>
            <a
              class="btn text-white btn-sm mr-2"
              :class="[{'btn-primary':activeView=='Richieste di supporto'},{'btn-secondary': activeView!='Richieste di supporto'}]"
              @click="activeView='Richieste di supporto'"
            >
              Richieste di supporto
              <span
                class="badge badge-pill"
                :class="[{'badge-success':activeView=='Richieste di supporto'},{'badge-dark': activeView!='Richieste di supporto'}]"
              >{{ richieste.length }}</span>
            </a>
            <a
              class="btn text-white btn-sm"
              :class="[{'btn-primary':activeView=='Lavori in corso'},{'btn-secondary': activeView!='Lavori in corso'}]"
              @click="activeView='Lavori in corso'"
            >
              Lavori in corso
              <span
                class="badge badge-pill"
                :class="[{'badge-success':activeView=='Lavori in corso'},{'badge-dark': activeView!='Lavori in corso'}]"
              >{{ lavori.length }}</span>
            </a>
            <a
              class="btn text-white btn-sm ml-2 mr-2"
              :class="[{'btn-primary':activeView=='Emergenze'},{'btn-secondary': activeView!='Emergenze'}]"
              @click="activeView='Emergenze'"
            >
              Emergenze
              <span
                class="badge badge-pill"
                :class="[{'badge-success':activeView=='Emergenze'},{'badge-dark': activeView!='Emergenze'}]"
              >{{ emergenze.length }}</span>              
            </a>
          </div>

          <!-- Contenuto scheda -->
          <div class="card m-b-20">
            <div class="card-body">
              <div class="text-left">
                <h3 class="font-bold">{{ activeView }}</h3>
                <span class="pull-right">
                  <i class="fa fa-refresh fa-2x" style="cursor: pointer;" @click="fetchData()"></i>
                </span>
              </div>

              <!-- Header delle schede -->
              <div class="text-left" v-if="activeView=='Segnalazioni inviate'">
                <h5 >Le seguenti squadre hanno individuato e segnalato i seguenti interventi</h5>
              </div>
              <div class="text-left" v-if="activeView=='Richieste di supporto'">
                <h5 >Le seguenti squadre hanno bisogno supporto</h5>
              </div>
              <div class="text-left" v-if="activeView=='Lavori in corso'">
                <h5 >In questo momento, in questo lotto, sono attivi i seguenti cantieri</h5>
              </div>
              <div class="text-left" v-if="activeView=='Emergenze'">
                <h5 >Elenco delle emergenze. Clicca su <i class="fa fa-eye"></i> per impostarle come lette</h5>
              </div>
              <div class="text-left">
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('buca')" v-if="activeView!='Emergenze'">Buca</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('sfalcio')" v-if="activeView!='Emergenze'">Sfalcio</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('segnaletica')" v-if="activeView!='Emergenze'">Segnaletica</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('pulizia')" v-if="activeView!='Emergenze'">Pulizia</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('rifiuto')" v-if="activeView=='Emergenze'">Rifiuto</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('rifiuto_speciale')" v-if="activeView=='Emergenze'">Rifiuto Spec.</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('emergenza_carreggiata')" v-if="activeView=='Emergenze'">Emergenza Carr.</span>                
              </div>
              <!-- Contenitore -->
              <div class="table-responsive mt-2">
                <!-- Segnalazioni -->
                <div v-if="activeView=='Segnalazioni inviate'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarSegnalazioni >= 100}, {'bg-success': progressBarSegnalazioni < 100}]" role="progressbar" :style="{width: `${this.progressBarSegnalazioni}%`}" :aria-valuenow="progressBarSegnalazioni" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="table table-striped table-sm" v-if="activeView=='Segnalazioni inviate'">
                  <thead class="thead-light">
                    <th>Intervento</th>
                    <th>Segnalato da</th>
                    <th>In data</th>
                    <th>Presso</th>
                    <th style="width: 180px;" v-if="segnalazioneDaAssociare!=0"></th>
                    <th style="width: 100px;"></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in segnalazioni" v-bind:key="key">
                      <td class="align-middle"><span class="badge text-uppercase" :class="classeInterventoBadge(item.intervento)">{{ item.intervento }}</span></td>
                      <td class="align-middle">{{ item.team_segnalatore.nome }}</td>
                      <td class="align-middle">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <!-- Segnalazione da associare -->
                      <td class="align-middle text-right" v-if="segnalazioneDaAssociare==item.id">
                        <select class="form-control" style="width: 160px;" v-model="teamDaAssociareASegnalazione">
                          <option v-for="(item, key) in teams" v-bind:key="key" :value="item.uid">{{ item.team }}</option>
                        </select>                                                                     
                      </td>
                      <td class="align-middle text-right" v-if="segnalazioneDaAssociare==item.id">
                        <button @click="segnalazioneDaAssociare=0;" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Chiudi e annulla', placement: 'left'}"><i class="mdi mdi-window-close"></i></button>
                        <button @click="associaSegnalazioneASquadra()" class="btn btn-success btn-sm text-white mr-2" v-tooltip="{content:'Assegna a squadra', placement: 'left'}"><i class="mdi mdi-send"></i></button>
                      </td>
                      <td v-if="segnalazioneDaAssociare!=item.id && segnalazioneDaAssociare!=0"></td>
                      <!-- Pulsanti di default -->
                      <td class="align-middle text-right"  v-if="segnalazioneDaAssociare!=item.id">
                        <button @click="mostraDettagliSegnalazione(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button>
                        <button @click="segnalazioneDaAssociare=item.id" v-if="item.intervento == 'buca' || item.intervento == 'sfalcio' || item.intervento == 'segnaletica'" class="btn btn-success btn-sm text-white mr-2" v-tooltip="{content:'Assegna a squadra', placement: 'left'}"><i class="mdi mdi-truck"></i></button>
                        <button @click="impostaSegnalazioneComeLetta(item.id)" v-if="item.intervento == 'rifiuto' || item.intervento == 'rifiuto_speciale' || item.intervento == 'emergenza_carreggiata'" class="btn btn-danger btn-sm mr-2" v-tooltip="{content:'Segna come letto e archivia', placement: 'left'}"><i class="mdi mdi-eye"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="activeView=='Segnalazioni inviate' && segnalazioni.length == 0">Niente da mostrare</div>
                
                <!-- Richieste di Supporto -->
                <div v-if="activeView=='Richieste di supporto'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarRichieste >= 100}, {'bg-success': progressBarRichieste < 100}]" role="progressbar" :style="{width: `${progressBarRichieste}%`}" :aria-valuenow="progressBarRichieste" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="table table-striped table-sm" v-if="activeView=='Richieste di supporto'">
                  <thead class="thead-light">
                    <th>Intervento</th>
                    <th>Richiesto da</th>
                    <th>In data</th>
                    <th>Presso</th>
                    <th style="width: 180px;" v-if="richiestaDaAssociare!=0"></th>
                    <th style="width: 100px;"></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in richieste" v-bind:key="key">
                      <td class="align-middle"><span class="badge text-uppercase" :class="classeInterventoBadge(item.intervento)">{{ item.intervento }}</span></td>
                      <td class="align-middle">{{ item.team_richiedente.nome }}</td>
                      <td class="align-middle">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <!-- Segnalazione da associare -->
                      <td class="align-middle text-right" v-if="richiestaDaAssociare==item.id">
                        <select class="form-control" style="width: 160px;" v-model="teamDaAssociareARichiesta">
                          <option v-for="(item, key) in teams" v-bind:key="key" :value="item.uid">{{ item.team }}</option>
                        </select>                                                                     
                      </td>
                      <td class="align-middle text-right" v-if="richiestaDaAssociare==item.id">
                        <button @click="richiestaDaAssociare=0;" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Chiudi e annulla', placement: 'left'}"><i class="mdi mdi-window-close"></i></button>
                        <button @click="associaRichiestaASquadra()" class="btn btn-success btn-sm text-white mr-2" v-tooltip="{content:'Assegna a squadra', placement: 'left'}"><i class="mdi mdi-send"></i></button>
                      </td>
                      <td v-if="richiestaDaAssociare!=item.id && richiestaDaAssociare!=0"></td>
                      <!-- Pulsanti di default -->
                      <td class="align-middle text-right"  v-if="richiestaDaAssociare!=item.id">
                        <button @click="mostraDettagliRichiesta(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button>
                        <button @click="richiestaDaAssociare=item.id" class="btn btn-success btn-sm text-white mr-2" v-tooltip="{content:'Assegna a squadra', placement: 'left'}"><i class="mdi mdi-truck"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="activeView=='Richieste di supporto' && richieste.length == 0">Niente da mostrare</div>

                <!-- Lavori in corso -->
                <div v-if="activeView=='Lavori in corso'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarLavori >= 100}, {'bg-success': progressBarLavori < 100}]" role="progressbar" :style="{width: `${progressBarLavori}%`}" :aria-valuenow="progressBarLavori" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="table table-striped table-sm" v-if="activeView=='Lavori in corso'">
                  <thead class="thead-light">
                    <th>Intervento</th>
                    <th>Squadra</th>
                    <th>Avviato in data</th>
                    <th>Presso</th>
                    <th style="width: 100px;"></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in lavori" v-bind:key="key">
                      <td class="align-middle"><span class="badge text-uppercase" :class="classeInterventoBadge(item.intervento)">{{ item.intervento }}</span></td>
                      <td class="align-middle">{{ item.team.nome }}</td>
                      <td class="align-middle">{{ formatTimestampToLocalDate(item.avvio) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <td class="align-middle text-right" >
                        <button @click="mostraDettagliLavoro(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="activeView=='Lavori in corso' && lavori.length == 0">Niente da mostrare</div>

                <!-- Emergenze -->
                <div v-if="activeView=='Emergenze'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarEmergenze >= 100}, {'bg-success': progressBarEmergenze < 100}]" role="progressbar" :style="{width: `${this.progressBarEmergenze}%`}" :aria-valuenow="progressBarEmergenze" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="table table-striped table-sm" v-if="activeView=='Emergenze'">
                  <thead class="thead-light">
                    <th>Intervento</th>
                    <th>Segnalato da</th>
                    <th>In data</th>
                    <th>Presso</th>
                    <th style="width: 180px;" v-if="segnalazioneDaAssociare!=0"></th>
                    <th style="width: 100px;"></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in emergenze" v-bind:key="key">
                      <td class="align-middle"><span class="badge text-uppercase" :class="classeInterventoBadge(item.intervento)">{{ item.intervento }}</span></td>
                      <td class="align-middle">{{ item.team_segnalatore.nome }}</td>
                      <td class="align-middle">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <!-- Pulsanti di default -->
                      <td class="align-middle text-right">
                        <button @click="mostraDettagliEmergenza(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button>
                        <button @click="impostaSegnalazioneComeLetta(item.id)" class="btn btn-danger btn-sm mr-2" v-tooltip="{content:'Segna come letto e archivia', placement: 'left'}"><i class="mdi mdi-eye"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="activeView=='Emergenze' && emergenze.length == 0">Niente da mostrare</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALI -->

    <!-- Modale di una SEGNALAZIONE -->
    <modal name="segnalazione" width="800" height="auto">
      <div v-if="forceRefreshSegnalazione && Object.entries(segnalazione).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase">{{ segnalazione.intervento }} <small>presso</small> {{ segnalazione.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('segnalazione');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <img :src="segnalazione.foto" style="width: 100%;">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(segnalazione.intervento)">{{ segnalazione.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ segnalazione.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Segnalato da</th>
                      <td>{{ segnalazione.team_segnalatore.nome }}</td>
                    </tr>
                    <tr>
                      <th>In data</th>
                      <td>{{ formatTimestampToLocalDate(segnalazione.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ segnalazione.strada }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td>{{ segnalazione.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td>{{ segnalazione.longitudine }}</td>
                    </tr>
                    <tr>
                      <th>Note</th>
                      <td>{{ segnalazione.note }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center">
                  <router-link :to="{name: 'modifica-segnalazione', params: {uuid: segnalazione.uuid}}" class="btn btn-primary btn-sm" v-if="tipologia=='B'">Modifica</router-link>                  
                </div>
              </div>
            </div> 
          </div>                     
        </div>
      </div>      
    </modal>

    <!-- Modale di una RICHIESTA -->
    <modal name="richiesta" width="800" height="auto">
      <div v-if="forceRefreshRichiesta && Object.entries(richiesta).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase"><small>Richiesta di supporto per</small> {{ richiesta.intervento }} <small>presso</small> {{ richiesta.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('richiesta');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <img :src="richiesta.foto" style="width: 100%;">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(richiesta.intervento)">{{ richiesta.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ richiesta.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Richiesta da</th>
                      <td>{{ richiesta.team_richiedente.nome }}</td>
                    </tr>
                    <tr>
                      <th>In data</th>
                      <td>{{ formatTimestampToLocalDate(richiesta.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ richiesta.strada }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td>{{ richiesta.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td>{{ richiesta.longitudine }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> 
          </div>                     
        </div>
      </div>      
    </modal>

    <!-- Modale di un lavoro -->
    <modal name="lavoro" width="800" height="auto">
      <div v-if="forceRefreshLavoro && Object.entries(lavoro).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase"><small>Intervento in corso, </small> {{ lavoro.intervento }} <small>presso</small> {{ lavoro.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('lavoro');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <img :src="lavoro.foto" style="width: 100%;">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(lavoro.intervento)">{{ lavoro.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ lavoro.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Team</th>
                      <td>{{ lavoro.team.nome }}</td>
                    </tr>
                    <tr>
                      <th>In data</th>
                      <td>{{ formatTimestampToLocalDate(lavoro.avvio) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ lavoro.strada }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td>{{ lavoro.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td>{{ lavoro.longitudine }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center">
                  <router-link :to="{name: 'modifica-lavoro', params: {uuid: lavoro.uuid}}" class="btn btn-primary btn-sm" v-if="tipologia=='B'">Modifica</router-link>                  
                </div>
              </div>
            </div> 
          </div>                     
        </div>
      </div>      
    </modal>

    <!-- Modale di una EMERGENZA -->
    <modal name="emergenza" width="800" height="auto">
      <div v-if="forceRefreshSegnalazione && Object.entries(emergenza).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase">{{ emergenza.intervento }} <small>presso</small> {{ emergenza.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('emergenza');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <img :src="emergenza.foto" style="width: 100%;">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(emergenza.intervento)">{{ emergenza.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ emergenza.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Segnalato da</th>
                      <td>{{ emergenza.team_segnalatore.nome }}</td>
                    </tr>
                    <tr>
                      <th>In data</th>
                      <td>{{ formatTimestampToLocalDate(emergenza.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ emergenza.strada }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td>{{ emergenza.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td>{{ emergenza.longitudine }}</td>
                    </tr>
                    <tr>
                      <th>Note</th>
                      <td>{{ emergenza.note }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> 
            <div class="row"><div class="col" align="center"><button class="btn btn-primary" @click="downloadEmergenza(emergenza)">Scarica</button></div></div> 
          </div>   
                           
        </div>
      </div>      
    </modal>

  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar
  },

  data() {
    return {
      loading: true,
      report: {
        bucheRiparate: 0,
        squadreAttive: 0,
        squadreTotali: 0,
        strade: 0,
        metriSfalciati: 0
      },
      reportLoading: false,
      reportInterval: undefined,

      tipologia: localStorage.getItem('tipologia'),

      // Teams
      teamsLoading: false,
      progressBarTeams: 0,
      progressBarTeamsInterval: undefined,
      gruppoSelezionato: "C",
      lotto: 1,
      teams: [],
      activeView: "Segnalazioni inviate",

      // Segnalazioni
      segnalazioniLoading: false,
      progressBarSegnalazioni: 0,
      progressBarSegnalazioniInterval: undefined,
      forceRefreshSegnalazione: true,
      segnalazioneDaAssociare: 0,
      teamDaAssociareASegnalazione: 0,
      segnalazione: {},
      segnalazioni: [],

      // Richieste di supporto
      richiesteLoading: false,
      progressBarRichieste: 0,
      progressBarRichiesteInterval: undefined,
      forceRefreshRichiesta: true,
      richiestaDaAssociare: 0,
      teamDaAssociareARichiesta: 0,
      richiesta: {},
      richieste: [],

      // Lavori in corso
      lavoriLoading: false,
      progressBarLavori: 0,
      progressBarLavoriInterval: undefined,
      forceRefreshLavoro: true,
      //richiestaDaAssociare: 0,
      //teamDaAssociareARichiesta: 0,
      lavoro: {},
      lavori: [],

      // Emergenze
      emergenzeLoading: false,
      progressBarEmergenze: 0,
      progressBarEmergenzeInterval: undefined,
      forceRefresEmergenze: true,
      emergenzaDaAssociare: 0,
      emergenza: {},
      emergenze: [],

      // PUSH
      permission: undefined
    };
  },

  mounted(){
    this.fetchData();
    this.permission = Notification.permission;
    this.toggleNotifications();
  },

  watch: {
    gruppoSelezionato() {
      this.fetchTeams();
    },

    lotto() {
      this.fetchDashboardData();
      this.fetchTeams();
      this.fetchSegnalazioni();
      this.fetchEmergenze();
      this.fetchRichieste();
      this.fetchLavori();
    },

    activeView() {
      localStorage.setItem('activeView', this.activeView);
    }
  },

  created() {
    // Get lotto
    if (localStorage.getItem("lotto")) {
      this.lotto = localStorage.getItem("lotto");
    }   

    // Get active view
    if (localStorage.getItem("activeView")) {
      this.activeView = localStorage.getItem("activeView");
    }  

    // Aggiorno i dati ogni 60 secondi    
    // var self=this;
    // this.reportInterval = setInterval(function(){
    //   self.fetchDashboardData();
    //   self.fetchSegnalazioni();
    //   self.fetchRichieste();
    //   self.fetchLavori();
    // }, 60000);
  },


  // beforeDestroy() {
  //   clearInterval(this.reportInterval);
  // },

  methods: {    
    // Fetch all data
    fetchData() {
      this.fetchDashboardData();
      this.fetchSegnalazioni();
      this.fetchEmergenze();
      this.fetchRichieste();
      this.fetchLavori();
    },

    // REPORT / DASHBOARD
    fetchDashboardData() {
      this.reportLoading = true;
      this.axios.get(`dashboard/${this.lotto}`).then(response=>{
        this.report = {
          bucheRiparate: response.data['buche_riparate'],
          squadreAttive: response.data['squadre_attive'],
          squadreTotali: response.data['squadre_totali'],
          strade: response.data['strade'],
          metriSfalciati: response.data['metri_sfalciati']     
        }
        this.reportLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.reportLoading = false;
        },1000)        
      })
    },

    // TEAMS
    // Si ottengono i dati sui team
    fetchTeams() {
      var params = "";
      if (this.gruppoSelezionato != "Tutte") {
        params = "?group=" + this.gruppoSelezionato;
      }      
      this.avviaProgressBarTeams();
      this.axios.get(`teams/${this.lotto}${params}`).then(response => {
        this.teamsLoading = false;
        this.teams = response.data;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.teamsLoading = false;
        },1000); 
      });
    },

    // Gestice il progresso del fetch dei teams
    avviaProgressBarTeams() {
      var self = this;
      this.teamsLoading = true;
      this.progressBarTeams = -25;
      this.progressBarTeamsInterval = setInterval(function(){
        self.progressBarTeams += 25;  
        if ( self.progressBarTeams >= 100 ) {
          self.resettaProgressBarTeams()
        }      
      }, 250);
    },

    resettaProgressBarTeams() {
      clearInterval(this.progressBarTeamsInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarTeams = 100;
      },2000);      
    },

    // SEGNALAZIONI
    // Si ottengono le segnalazioni "da gestire"
    fetchSegnalazioni() {      
      this.avviaProgressBarSegnalazioni();
      this.axios.get(`notice/${this.lotto}?interventi=buca,sfalcio,segnaletica,pulizia`).then(response => {        
        this.segnalazioni = response.data;
        this.segnalazioniLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.segnalazioniLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle segnalazioni
    avviaProgressBarSegnalazioni() {
      var self = this;
      this.segnalazioniLoading = true;
      this.progressBarSegnalazioni = -20;
      this.progressBarSegnalazioniInterval = setInterval(function(){
        self.progressBarSegnalazioni += 20;
        if ( self.progressBarSegnalazioni >= 100 ) {
          self.resettaProgressBarSegnalazioni()
        }
      }, 400);
    },

    resettaProgressBarSegnalazioni() {
      clearInterval(this.progressBarSegnalazioniInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarSegnalazioni = 100;
      },2000);      
    },

    // Associa una segnalazione ad una squadra
    associaSegnalazioneASquadra() {
      if (this.teamDaAssociareASegnalazione != 0){
        var jsonBody = {
          team: this.teamDaAssociareASegnalazione
        }
        this.axios.post(`notice/${this.lotto}/send/${this.segnalazioneDaAssociare}`, jsonBody).then(response=>{
          if(response.data['success']){
            this.$swal.fire(
              'Perfetto!',
              'Team correttamente assegnato alla segnalazione',
              'success'
            )          
            this.fetchSegnalazioni();
          }
        })
      }      
    },

    // Imposta segnalazione come letta
    impostaSegnalazioneComeLetta(id_segnalazione) {
      this.$swal
        .fire({
          title: "Sicuro?",
          text: "La segnalazione verrà archiviata e sarà disponibile in Mostra > Segnalazioni",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Sì, archivia"
        })
        .then(result => {
          if (result.value) {
            this.axios.put(`notice/${this.lotto}/read/${id_segnalazione}`).then(response=>{
            if(response.data['success']){
              this.$swal.fire(
                'Perfetto!',
                'Hai correttamente archiviato la segnalazione, da ora sarà disponibile nella sezione "storico"',
                'success'
              )  
              this.fetchSegnalazioni();
            }
          })
          }
        });
    },

    // RICHIESTE
    // Si ottengono le richieste "da gestire"
    fetchRichieste() {      
      this.avviaProgressBarRichieste();
      this.axios.get(`support/${this.lotto}`).then(response => {        
        this.richieste = response.data;
        this.richiesteLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.richiesteLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle richieste
    avviaProgressBarRichieste() {
      var self = this;
      this.richiesteLoading = true;
      this.progressBarRichieste = -20;
      this.progressBarRichiesteInterval = setInterval(function(){
        self.progressBarRichieste += 20;
        if(self.progressBarRichieste >= 100) {
          self.resettaProgressBarRichieste();
        }
      }, 400);
    },

    resettaProgressBarRichieste() {
      clearInterval(this.progressBarRichiesteInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarRichieste = 100;
      },2000);      
    },

    // Associa una richiesta ad una squadra
    associaRichiestaASquadra() {
      if (this.teamDaAssociareARichiesta != 0){
        var jsonBody = {
          team: this.teamDaAssociareARichiesta
        }
        this.axios.post(`support/${this.lotto}/send/${this.richiestaDaAssociare}`, jsonBody).then(response=>{
          if(response.data['success']){
            this.$swal.fire(
              'Perfetto!',
              'Team correttamente assegnato alla richiesta',
              'success'
            )          
            this.fetchRichieste();
          }
        })
      }      
    },

    // LAVORI
    // Si ottengono i lavori in corso
    fetchLavori() {      
      this.avviaProgressBarLavori();
      this.axios.get(`dockyard/${this.lotto}`).then(response => {        
        this.lavori = response.data;
        this.lavoriLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.lavoriLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle richieste
    avviaProgressBarLavori() {
      var self = this;
      this.lavoriLoading = true;
      this.progressBarLavori = -20;
      this.progressBarLavoriInterval = setInterval(function(){
        self.progressBarLavori += 20;
        if(self.progressBarLavori >= 100) {
          self.resettaProgressBarLavori();
        }
      }, 400);
    },

    resettaProgressBarLavori() {
      clearInterval(this.progressBarLavoriInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarLavori = 100;
      },2000);      
    },

    // EMERGENZE
    // Si ottengono le emergenze 
    fetchEmergenze() {      
      this.avviaProgressBarEmergenze();
      this.axios.get(`notice/${this.lotto}?interventi=emergenza_carreggiata,rifiuto_speciale,rifiuto`).then(response => {        
        this.emergenze = response.data;
        this.emergenzeLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.emergenzeLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle emergenze
    avviaProgressBarEmergenze() {
      var self = this;
      this.emergenzeLoading = true;
      this.progressBarEmergenze = -20;
      this.progressBarEmergenzeInterval = setInterval(function(){
        self.progressBarEmergenze += 20;
        if ( self.progressBarEmergenze >= 100 ) {
          self.resettaProgressBarEmergenze()
        }
      }, 400);
    },

    resettaProgressBarEmergenze() {
      clearInterval(this.progressBarEmergenzeInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarEmergenze = 100;
      },2000);      
    },

    downloadEmergenza(emergenza) {
      var backupEmergenza = JSON.parse(JSON.stringify(emergenza))
      backupEmergenza['data'] = new Date ( backupEmergenza['tempo'] * 1000).toLocaleDateString();
      this.axios.post(`report/emergenza`, backupEmergenza, {responseType: 'blob'}).then(response=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${emergenza.intervento}_${emergenza.strada}_${emergenza.id}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
    },

    // Viene cambiato il lotto
    // da 1 a 2 o viceversa
    cambiaLotto() {
      if (this.lotto == 1) {
        this.lotto = 2;
      } else {
        this.lotto = 1;
      }
      localStorage.setItem("lotto", this.lotto);
    },

    // Mostra il modale con i dettagli di una 
    // segnalazione
    mostraDettagliSegnalazione(segnalazione) {
      this.segnalazione = segnalazione;
      this.$modal.show('segnalazione');
      // turnaround
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      // turnaround end
    },

    // Mostra il modale con i dettagli di una 
    // richiesta
    mostraDettagliRichiesta(richiesta) {
      this.richiesta = richiesta;
      this.$modal.show('richiesta');
      // turnaround
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      // turnaround end
    },

    // Mostra il modale con i dettagli di un
    // lavoro in corso
    mostraDettagliLavoro(lavoro) {
      this.lavoro = lavoro;
      this.$modal.show('lavoro');
      // turnaround
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      // turnaround end
    },

    // Mostra il modale con i dettagli di una 
    // segnalazione
    mostraDettagliEmergenza(emergenza) {
      this.emergenza = emergenza;
      this.$modal.show('emergenza');
      // turnaround
      this.forceRefreshEmergenza = !this.forceRefreshEmergenza;
      this.forceRefreshEmergenza = !this.forceRefreshEmergenza;
      // turnaround end
    },

    // Classe Intervento
    // Individua la classe di badge
    // in base all'intervento
    classeInterventoBadge(intervento) {
      if (intervento=='buca'){
        return 'badge-success';
      }      
      if (intervento=='sfalcio'){
        return 'badge-primary';
      }      
      if (intervento=='segnaletica'){
        return 'badge-dark';
      }      
      if (intervento=='rifiuto'){
        return 'badge-warning';
      }      
      if (intervento=='rifiuto_speciale'){
        return 'badge-purple';
      }      
      if (intervento=='emergenza_carreggiata'){
        return 'badge-danger';
      }      
      if (intervento=='pulizia'){
        return 'badge-secondary';
      }
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts){
      const today = new Date();
      var tsDate = new Date(ts*1000);
      if (today.getDate() == tsDate.getDate() && today.getMonth() == tsDate.getMonth() && today.getFullYear() == tsDate.getFullYear()) {
        return `Oggi, ${tsDate.toLocaleTimeString()}`
      } else {
        return tsDate.toLocaleString();
      }
    },

    /**
      Toggle notifications

      Enable / disable desktop notifications
     */
    toggleNotifications() {
      if (Notification.permission !== "granted") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            this.getUserRegistrationToken();
          }
          this.permission = permission;
        });
      }
    },

    changeNotificationPermission(){
      var self = this;
      Notification.requestPermission().then(function (permission) {
      // If the user accepts, let's create a notification
        if (permission === "granted") {
          console.log('Notifcation granted')
        } else {
          console.log('Check for notifications')
          self.$swal.fire('Abilita le notifiche PUSH', 'Le notifiche per questo dispositivo sono state disabilitate. Si prega di riattivarle tramite le impostazioni del browser.', 'warning')
        }
      });
    },

    /**
      Get user registration token for firebase CM

      Initially this makes a network call, once retrieved
      subsequent calls to getToken will return from cache.
     */
    getUserRegistrationToken() {
      this.$messaging
        .getToken()
        .then(currentToken => {
          if (currentToken) {
            this.sendTokenToServer(currentToken);
          }
        })
        .catch(err => {
          console.log("An error occurred while retrieving token. ", err);
        });
    },

    /**
      Send notification token to server
     */
    sendTokenToServer(tok) {
      var formData = new FormData();
      formData.append("notification_token", tok);
      this.axios.post("/notifications", formData).then(
        response => {
          if (response.data["success"]) {
            localStorage.setItem("notification_token", tok);
          }
        },
        error => {
          console.log(error)
          this.$swal.fire({
            type: "error",
            title: "Errore",
            text: "Errore nella attivazione delle notifiche PUSH"
          });
        }
      );
    },
  }
};
</script>

<style>
</style>